/**
 * Image download helper composable
 */
export const useImageDownload = () => {

  //Download image helper
  const downloadImage = url => {

    //Nothing to download
    if (!url) {
      return
    }

    //Trigger the download via a temporary anchor. The `url` is a server-signed
    //S3 URL with `Content-Disposition: attachment`, so the browser downloads the
    //file instead of navigating to it. We can't fetch the image into a blob first
    //(the old approach) because the images live on a cross-origin S3 bucket with
    //no CORS, which makes `fetch` fail; and the anchor `download` attribute is
    //ignored cross-origin, so we rely on the attachment disposition instead.
    const link = document.createElement('a')
    link.href = url

    //Add to body and click
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  //Expose interface
  return {
    downloadImage,
  }
}
